const backEndUrl = "https://us-central1-kinetic-object-314621.cloudfunctions.net/webDeals";
const paymentUrl = "https://us-west1-kinetic-object-314621.cloudfunctions.net/braintree";
const messageUrl = "https://us-west2-kinetic-object-314621.cloudfunctions.net/acs_slack";

const requestOptions = {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
};

async function fetchFromBackend(url, params) {
  const newPostOption = { ...requestOptions, body: JSON.stringify(params) };
  try {
    const response = await fetch(url, newPostOption);
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    return response.json();
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    return null;
  }
}

async function getProduct(params) {
  const payload = { q: "web_items" };
  Object.assign(payload, params);
  return fetchFromBackend(backEndUrl, payload);
}

async function getToken(params) {
  const payload = { q: "token" };
  Object.assign(payload, params);
  return fetchFromBackend(paymentUrl, payload);
}

async function getShipping(params) {
  const payload = { q: "getShipping" };
  Object.assign(payload, params);
  return fetchFromBackend(paymentUrl, payload);
}

async function payment(params) {
  const payload = { q: "payment" };
  Object.assign(payload, params);
  return fetchFromBackend(paymentUrl, payload);
}

async function getAddresses(params) {
  const payload = { q: "address_request" };
  Object.assign(payload, params);
  return fetchFromBackend(paymentUrl, payload);
}

async function updateProduct(params) {
  const payload = { q: "update_product" };
  Object.assign(payload, params);
  return fetchFromBackend(backEndUrl, payload);
}

async function updateAddresses(params) {
  const payload = { q: "address_update" };
  Object.assign(payload, params);
  return fetchFromBackend(paymentUrl, payload);
}

async function getCoupon(params) {
  const payload = { q: "coupon" };
  Object.assign(payload, params);
  return fetchFromBackend(paymentUrl, payload);
}

async function sendSlackMessage(params) {
  const payload = { q: "message" };
  Object.assign(payload, params);
  return fetchFromBackend(messageUrl, payload);
}


export { getProduct, getToken, getCoupon, getAddresses, updateAddresses,
          updateProduct, getShipping, payment, sendSlackMessage

};
